import axios from './axios';

export const fetchPlayoffStatus = async () => {
    const response = await axios.get('/playoff');
    return response.data;
};

export const startPlayoffRun = async (userTeamID) => {
    const response = await axios.post('/playoff/start', { userTeamID });
    return response.data;
};

export const playNextPlayoffGame = async (substitutions) => {
    const response = await axios.post('/playoff/play', { substitutions });
    return response.data;
};

export const generatePlayoffBracket = async () => {
    const response = await axios.post('/playoff/generate');
    return response.data;
};

export const fetchPlayoffPointsMonthly = async (monthYear) => {
    const response = await axios.get(`/playoff/points/leaderboard/monthly/${monthYear}`);
    return response.data;
};

export const fetchPlayoffPointsAllTime = async () => {
    const response = await axios.get('/playoff/points/leaderboard/alltime');
    return response.data;
};
